import Attachment from "./Attachment";
export default class PdfTemplateImage {
    constructor(image) {
        this.id = image.id;
        this.x1 = image.x1;
        this.y1 = image.y1;
        this.width = image.width;
        this.height = image.height;
        this.image_name = image.image_name;
        this.template_id = image.template_id;
        this.file = image.file;
        this.attachment = new Attachment(image.attachment);
    }

    static getImages(templateImages) {
        const images = [];
        templateImages.forEach(image => {
            images.push(new PdfTemplateImage(image));
        });
        return images;
    }

    static async attachImages(updatedTemplate, templateWithFiles) {
        for (const image of templateWithFiles.images) {
            if (image.file) {
                //map image from browser to database
                const foundImage = updatedTemplate.images.find(updatedImage => {
                    return updatedImage.x1 == image.x1 &&
                        updatedImage.y1 == image.y1 &&
                        updatedImage.width == image.width &&
                        updatedImage.height == image.height &&
                        updatedImage.image_name == image.image_name;
                });
                if (foundImage) {
                    await Attachment.uploadFile(foundImage.id, "pdf_template_images", image.file)
                }
            }
        }
    }
}